/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Session_ConflictInputs */

const en_us2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These workouts could not be imported. Try again.`)
};

const pt_br2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para importar esses treinos. Tente de novo.`)
};

const es_419_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron importar estos entrenamientos. Inténtalo de nuevo.`)
};

const pt_pt2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível importar estes treinos. Tenta outra vez.`)
};

const fr_fr2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces séances n'ont pas pu être importées. Réessaie.`)
};

const de_de2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Trainings konnten nicht importiert werden. Versuch es noch mal.`)
};

const it_it2_import_session_conflict = /** @type {(inputs: Import_Session_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile importare questi allenamenti. Riprova.`)
};

/**
* | output |
* | --- |
* | "These workouts could not be imported. Try again." |
*
* @param {Import_Session_ConflictInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const import_session_conflict = /** @type {((inputs?: Import_Session_ConflictInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Session_ConflictInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_import_session_conflict(inputs)
	if (locale === "es-419") return es_419_import_session_conflict(inputs)
	if (locale === "pt-PT") return pt_pt2_import_session_conflict(inputs)
	if (locale === "fr-FR") return fr_fr2_import_session_conflict(inputs)
	if (locale === "de-DE") return de_de2_import_session_conflict(inputs)
	if (locale === "it-IT") return it_it2_import_session_conflict(inputs)
	return en_us2_import_session_conflict(inputs)
});
export { import_session_conflict as "import.session_conflict" }